import {
    Typography,
    Button,
    Container,
    Box,
    Grid,
    useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { NavLink, useHistory } from "react-router-dom";
import { HeroStyle } from "../Styles/LandingStyles";

const NotFound = () => {
    const classes = HeroStyle();
    const theme = useTheme();
    const isActive = useMediaQuery(theme.breakpoints.down("sm"));
    const history = useHistory()

    const handleClick = (event: any) => {
        event.preventDefault();
        const cameFromSameOrigin = document.referrer && new URL(document.referrer).origin === window.location.origin;

        if (cameFromSameOrigin) {
            history.goBack();
        } else {
            history.replace("/deals"); // replace instead of push to avoid stacking
        }
    }

    return (
        <>  
            <Box className={classes.hero} component="section">
                <Container fixed>
                    <Grid container alignItems="center" spacing={0}>
                        <Grid item md={6}>
                            <Box
                                data-aos="fade-up"
                                data-aos-duration="1200"
                                ml={isActive ? 0 : 3}
                            >
                                <Typography
                                variant="h1"
                                className="font-family-Poppin fw-normal"
                                >
                                404. <br />
                                    <Typography
                                        component="span"
                                        variant="h1"
                                        className="font-family-Poppin"
                                    >
                                        Page Not Found.
                                    </Typography>
                                </Typography>
                                <Typography
                                variant="body1"
                                className="font-family-Poppin white"
                                >
                                If you are looking for exclusive access,
                                <br /> the{" "}
                                <Box
                                    component="b"
                                    fontWeight="bold"
                                    className="font-family-Poppin white"
                                >
                                    you are on the wrong page.
                                </Box>
                                <br /> <br />
                                </Typography>
                                <Button
                                    variant="contained"
                                    className="hero-blue-bg white"
                                    size="large"
                                    onClick={(e) => handleClick(e)}
                                >
                                    Go Back
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
}

export default NotFound;